export default __webpack_public_path__ + "static/energy-73cc73519f4326e18143c8f7e0ba1ea8.jpg";